import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://ar-mundi.com';

const client = axios.create({ baseURL: API_URL });

client.interceptors.request.use(cfg => {
  const token = localStorage.getItem('armundi_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

client.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('armundi_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default client;
